/*eslint-disable */
var $ = window.jQuery = require('jquery');

import {
mapGetters,
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'members-professional-categories',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      display_name:'',
      createMemberFiltersPopup:false,
      getMemberFiltersListState:{},
      getMemberFiltersListResults:[],
      updateMemberFiltersPopup:false,
      updateMemberFiltersId:'',
      removeMemberFiltersPopup:false,
      removeMemberFiltersId:'',
      createProSubCatState:false,
      mainCatId:'',
      sub_category:'',
      removeProCatFilterId:'',
      removeProCatFilterPopup:false,
      updateProCatFilterId:'',
      updateProCatFilterPopup:false
    }
  },
  computed: {
    ...mapGetters([
      'getMemberMainFiltersByIdGetters'
    ]),
    getMemberFiltersListFun(){
      this.getMemberFiltersListState = this.$store.getters.getMemberMainFiltersByIdGetters.data;
      return
    },
    getMemerFilterInitialStateFun(){
      if(this.getMemberFiltersListState != undefined){
        this.getMemberFiltersListResults = this.getMemberFiltersListState.category
      }
      return
    }
  },
  mounted () {
    this.getMemberFiltersListFun
    this.getMemerFilterInitialStateFun
  },
  methods: {
    getMemberFiltersListAgainMethod(){
      this.$store.dispatch('getMemberMainFilterDetailsByIdAction', {id:this.$route.params.filterId}).then((res) => {
        this.getMemberFiltersListState = res.data.data
      })
    },
    createMemberFiltersPopupFun(){
      this.createMemberFiltersPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closeMemberFiltersPopupFun(){
      this.createMemberFiltersPopup = false
      $('body').removeClass('body_right_scroll_remove')
    },
    createMemberFilterBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            category:this.display_name,
            member_category : this.$route.params.filterId
          }
          this.$store.dispatch('createMemberProfessionalFilterAction', data).then((res) => {
            toast.success(res.data.msg);
            this.submitted = false
            this.getMemberFiltersListAgainMethod()
            // this.closeMemberFiltersPopupFun()
            this.display_name = ''
            this.$validator.reset();
          }).catch((err)=>{
            this.submitted = false
            toast.error(err.data.msg);
          })
        }
      })
    },
    updateMemberFiltersPopupEnabledFun(filterId,filterData){
      this.updateMemberFiltersId = filterId
      this.updateMemberFiltersPopup = true
      this.display_name = filterData.category
      $('body').addClass('body_right_scroll_remove')
    },
    closeUpdateMemberFiltersPopupFun(){
      this.updateMemberFiltersPopup = false
      this.updateMemberFiltersId = ''
      this.display_name = ''
      $('body').removeClass('body_right_scroll_remove')
    },
    updateMemberFilterBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            category:this.display_name,
            member_category : this.$route.params.filterId
          }
          this.$store.dispatch('updateMemberProfessionalFilterAction',{data:{data:data,id:this.updateMemberFiltersId}}).then((res) => {
            toast.success(res.data.msg);
            this.submitted = false
            this.getMemberFiltersListAgainMethod()
            this.closeUpdateMemberFiltersPopupFun()
          }).catch((err)=>{
            this.submitted = false
            toast.error(err.data.msg);
          })
        }
      })
    },
    removeMemberFiltersPopupEnabledFun(filterId){
      this.removeMemberFiltersId = filterId
      this.removeMemberFiltersPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closeRemoveMemberFiltersPopupFun(){
      this.removeMemberFiltersPopup = false
      this.removeMemberFiltersId = ''
      $('body').removeClass('body_right_scroll_remove')
    },
    removedMemberFiltersPopupFun(){
      this.$store.dispatch('deleteMemberProfessionalFilterAction',{id:this.removeMemberFiltersId}).then((res) => {
        toast.success(res.data.msg);
        this.getMemberFiltersListAgainMethod()
        this.closeRemoveMemberFiltersPopupFun()
      }).catch((err)=>{
        toast.error(err.data.msg);
      })
    },
    createProSubCatPopupFun(id){
      this.createProSubCatState = true
      this.mainCatId = id
      $('body').addClass('body_right_scroll_remove')
    },
    closeProSubCatPopupFun(){
      this.createProSubCatState = false
      this.mainCatId = ''
      $('body').removeClass('body_right_scroll_remove')
    },
    createProSubCateBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            category:this.mainCatId,
            sub_category : this.sub_category
          }
          this.$store.dispatch('createMemberProfessionalSubFilterAction', data).then((res) => {
            toast.success(res.data.msg);
            this.submitted = false
            this.sub_category = ''
            this.$validator.reset();
            this.getMemberFiltersListAgainMethod()
            // this.closeProSubCatPopupFun()
          }).catch((err)=>{
            this.submitted = false
            toast.error(err.data.msg);
          })
        }
      })
    },
    updateProSubCatPopupEnabledFun(filterId,filterData){
      this.sub_category = filterData.sub_category
      this.updateProCatFilterId = filterId
      this.updateProCatFilterPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closeUpdateProSubCatPopupFun(){
      this.updateProCatFilterPopup = false
      this.updateProCatFilterId = ''
      this.sub_category = ''
      $('body').removeClass('body_right_scroll_remove')
    },
    updateProSubCateBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            sub_category : this.sub_category
          }
          this.$store.dispatch('updateMemberProfessionalSubFilterAction',{data:{id:this.updateProCatFilterId,data:data}}).then((res) => {
            toast.success(res.data.msg);
            this.submitted = false
            this.getMemberFiltersListAgainMethod()
            this.closeUpdateProSubCatPopupFun()
          }).catch((err)=>{
            this.submitted = false
            toast.error(err.data.msg);
          })
        }
      })
    },
    removeProSubCatPopupEnabledFun(filterId){
      this.removeProCatFilterId = filterId
      this.removeProCatFilterPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closeProSubCatPopupPopupFun(){
      this.removeProCatFilterPopup = false
      this.removeProCatFilterId = ''
      $('body').removeClass('body_right_scroll_remove')
    },
    removedProSubCatPopupFun(){
      this.$store.dispatch('deleteMemberProfessionalSubFilterAction',{id:this.removeProCatFilterId}).then((res) => {
        toast.success(res.data.msg);
        this.getMemberFiltersListAgainMethod()
        this.closeProSubCatPopupPopupFun()
      }).catch((err)=>{
        toast.error(err.data.msg);
      })
    },
  },
  watch: {
    getMemberFiltersListFun(){
      return this.$store.getters.getMemberMainFiltersByIdGetters
    },
    getMemerFilterInitialStateFun(){
      if(this.getMemberFiltersListState != undefined){
        this.getMemberFiltersListResults = this.getMemberFiltersListState.results
      }
      return
    }
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('body_right_scroll_remove')
    next();
  },
}